export default class Section {
  formData() {
    throw new Error('Subclass responsibility');
  }
}
